import React from "react"
import { VirtualItem } from "@tanstack/react-virtual"
import { Result } from "./result"

// Shared constant for estimated size
export const ESTIMATED_RESULT_SIZE = 80

interface VirtualizedResultsProps {
  virtualItems: VirtualItem[]
  getTotalSize: () => number
  measureElement: (el: Element | null) => void
  results: any[]
  domains?: any[]
  selectedIds: number[]
  leadsLists: { id: number; name: string }[]
  campaigns: { id: number; name: string }[]
  onSelect: (ids: number[]) => void
  onReveal: (id: number) => void
  onSaveEmail: (name: string, listId: number, emailId: number) => void
  onSaveCampaign: (name: string, campaignId: number, emailId: number) => void
  similarityThresholds?: {
    medium: number
    high: number
  }
  matchingKeywords?: Record<number, string[]>
  clickToCopy?: boolean
}

// Shared component for rendering virtualized results
export const VirtualizedResults: React.FC<VirtualizedResultsProps> = ({
  virtualItems,
  getTotalSize,
  measureElement,
  results,
  domains,
  selectedIds,
  leadsLists,
  campaigns,
  onSelect,
  onReveal,
  onSaveEmail,
  onSaveCampaign,
  similarityThresholds,
  matchingKeywords,
  clickToCopy = false,
}) => {
  return (
    <div
      style={{
        height: `${getTotalSize()}px`,
        width: "100%",
        position: "relative",
      }}
    >
      {virtualItems.map((virtualItem) => {
        const result = results[virtualItem.index]
        if (!result) return null

        return (
          <div
            key={virtualItem.key}
            data-index={virtualItem.index}
            ref={measureElement}
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              transform: `translateY(${virtualItem.start}px)`,
            }}
          >
            <Result
              result={result}
              domain={domains?.find((d) => d.value === result.domain) || null}
              selected={selectedIds.includes(result.id)}
              leadsLists={leadsLists}
              campaigns={campaigns}
              onSelect={onSelect}
              handleReveal={() => onReveal(result.id)}
              handleLeadsListSave={onSaveEmail}
              handleCampaignsSave={onSaveCampaign}
              similarityThresholds={similarityThresholds}
              matchingKeywords={matchingKeywords?.[result.id]}
              clickToCopy={clickToCopy}
            />
          </div>
        )
      })}
    </div>
  )
}
